import { Grid } from "@mui/material";
import TimePickerField from "../../../../components/Dashboard/TimePickerField";
import { useIntl } from "../../../../contexts/IntlContext";

type Props = {
  dailyStartTime: string;
  dailyEndTime: string;
  onDailyStartTimeChange: (value: string) => void;
  onDailyEndTimeChange: (value: string) => void;
  disabled?: boolean;
  error?: string;
  /** HH:mm; só vale no primeiro dia do período (quando ele é o primeiro dia permitido). */
  minStartTime?: string;
  startTimeHelperText?: string;
  startTimeError?: boolean;
};

/** Horário diário único (início/fim), repetido em todos os dias do período. */
export default function DailyTimeRangeFields({
  dailyStartTime,
  dailyEndTime,
  onDailyStartTimeChange,
  onDailyEndTimeChange,
  disabled,
  error,
  minStartTime,
  startTimeHelperText,
  startTimeError,
}: Props) {
  const intl = useIntl();
  return (
    <>
      <Grid item xs={12} md={6}>
        <TimePickerField
          label={intl.formatMessage({ id: "liveStreams.period.dailyStartTime" })}
          value={dailyStartTime}
          onChange={onDailyStartTimeChange}
          minTime={minStartTime}
          helperText={startTimeHelperText}
          error={startTimeError}
          disabled={disabled}
          fullWidth
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <TimePickerField
          label={intl.formatMessage({ id: "liveStreams.period.dailyEndTime" })}
          value={dailyEndTime}
          onChange={onDailyEndTimeChange}
          disabled={disabled}
          error={Boolean(error)}
          helperText={error}
          fullWidth
        />
      </Grid>
    </>
  );
}
